import type { SVGProps } from "react";

export function IconWayflyerW(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.775 5V7.725H18.2625V7.8L16.4625 14.6H16.4L14 7.1625H8.9125V9.9H9.6125V9.9875L8.2 14.6H8.1125L6.625 9H3V11.7375H4.525V11.8125L6.5625 19H9.3875L12.1875 11.25H12.25L15.1875 19H18L22 5H15.775Z"
        fill="currentColor"
      />
    </svg>
  );
}
